import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Dialog as DialogComponent } from '@lean-body/components/molecules';
import { MediaBreakPointUp, Colors } from '@lean-body/components/styles';
import { DialogPageName } from '@lean-body/src/domain/dialog';
import { ButtonType, Button } from '../atoms';
import { useNavigate } from 'react-router-dom';
export const ReleaseNotificationModal = ({ close, dialog }) => {
    const navigate = useNavigate();
    let linkText;
    if (dialog.buttonLabel) {
        linkText = dialog.buttonLabel;
    }
    else if (dialog.pageName === DialogPageName.activity) {
        linkText = 'アクティビティを見る';
    }
    else {
        linkText = '詳細を見てみる';
    }
    const moveToLink = () => {
        if (dialog.linkPath) {
            close();
            navigate(dialog.linkPath);
        }
        else {
            window.open(dialog.linkUrl, '_blank');
        }
    };
    return (React.createElement(DialogComponent, { onClickCancel: close, isCloseButton: true, classObject: styles.dialog, content: React.createElement("div", { className: css(styles.container) },
            React.createElement("img", { className: css(styles.headImg), src: dialog.thumbnailURL }),
            React.createElement("div", { className: css(styles.content) },
                React.createElement("div", { className: css(styles.title) }, dialog.title),
                React.createElement("div", { className: css(styles.description) },
                    React.createElement("p", null, dialog.description)),
                (dialog.linkPath || dialog.linkUrl) && (React.createElement(Button, { buttonType: ButtonType.pink, className: css(styles.button), onClick: moveToLink, isRadius: true },
                    React.createElement("div", { className: css(styles.buttonText) }, linkText))))) }));
};
const styles = StyleSheet.create({
    container: {
        borderRadius: 8,
        overflow: 'hidden',
        backgroundColor: Colors.White,
    },
    dialog: {
        top: '50%',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '16px 18px 20px',
        [MediaBreakPointUp.XL]: {
            paddingBottom: 30,
        },
    },
    headImg: {
        width: '100%',
    },
    title: {
        fontWeight: 600,
        textAlign: 'center',
        whiteSpace: 'pre-wrap',
        [MediaBreakPointUp.XL]: {
            fontSize: 18,
        },
    },
    description: {
        fontSize: 14,
        margin: '8px 0 16px',
        lineHeight: '21px',
        fontWeight: 400,
        whiteSpace: 'pre-wrap',
    },
    button: {
        display: 'block',
        width: '100%',
        minHeight: 48,
        [MediaBreakPointUp.XL]: {
            width: 'auto',
            minWidth: 320,
            minHeight: 60,
        },
    },
    buttonText: {
        fontSize: 16,
        fontWeight: 'bold',
        [MediaBreakPointUp.XL]: {
            fontSize: 20,
        },
    },
});
